
export const clientDocuments = [
  {
    id: 1,
    name: '2024 Federal Tax Return (1040)',
    category: 'Tax Returns',
    date: '2025-03-15',
    size: '2.4 MB',
    status: 'Ready',
    icon: 'ri-file-text-line',
  },
  {
    id: 2,
    name: '2024 State Tax Return - California',
    category: 'Tax Returns',
    date: '2025-03-15',
    size: '1.8 MB',
    status: 'Ready',
    icon: 'ri-file-text-line',
  },
  {
    id: 3,
    name: 'W-2 Wage Statement - Employer',
    category: 'Income Documents',
    date: '2025-02-01',
    size: '340 KB',
    status: 'Ready',
    icon: 'ri-file-list-3-line',
  },
  {
    id: 4,
    name: '1099-NEC Freelance Income',
    category: 'Income Documents',
    date: '2025-01-28',
    size: '210 KB',
    status: 'Processing',
    icon: 'ri-file-list-3-line',
  },
  {
    id: 5,
    name: 'Quarterly Estimated Tax Summary Q1',
    category: 'Estimates',
    date: '2025-04-10',
    size: '520 KB',
    status: 'Pending Review',
    icon: 'ri-file-chart-line',
  },
  {
    id: 6,
    name: 'Business Expense Report 2024',
    category: 'Business',
    date: '2025-02-20',
    size: '1.1 MB',
    status: 'Ready',
    icon: 'ri-file-chart-line',
  },
  {
    id: 7,
    name: 'Mortgage Interest Statement (1098)',
    category: 'Deductions',
    date: '2025-01-15',
    size: '180 KB',
    status: 'Ready',
    icon: 'ri-file-list-3-line',
  },
  {
    id: 8,
    name: 'Charitable Donation Receipts 2024',
    category: 'Deductions',
    date: '2025-02-05',
    size: '890 KB',
    status: 'Ready',
    icon: 'ri-file-list-3-line',
  },
];

export const documentCategories = [
  'All Documents',
  'Tax Returns',
  'Income Documents',
  'Estimates',
  'Business',
  'Deductions',
];

export const upcomingAppointments = [
  {
    id: 1,
    title: 'Tax Strategy Review',
    date: '2025-06-18',
    time: '10:00 AM - 11:00 AM',
    type: 'In-Person',
    advisor: 'Alejandro Monge',
    status: 'Confirmed',
  },
  {
    id: 2,
    title: 'Quarterly Estimated Tax Planning',
    date: '2025-07-02',
    time: '2:00 PM - 3:00 PM',
    type: 'Video Call',
    advisor: 'Alejandro Monge',
    status: 'Confirmed',
  },
];

export const pastAppointments = [
  {
    id: 3,
    title: 'Annual Tax Return Filing',
    date: '2025-03-10',
    time: '9:00 AM - 10:30 AM',
    type: 'In-Person',
    advisor: 'Alejandro Monge',
    status: 'Completed',
  },
  {
    id: 4,
    title: 'Business Deduction Consultation',
    date: '2025-01-22',
    time: '11:00 AM - 12:00 PM',
    type: 'Phone Call',
    advisor: 'Alejandro Monge',
    status: 'Completed',
  },
];

export const availableTimeSlots = [
  '9:00 AM',
  '10:00 AM',
  '11:00 AM',
  '1:00 PM',
  '2:00 PM',
  '3:00 PM',
  '4:00 PM',
];

export const appointmentTypes = [
  'Tax Strategy Consultation',
  'Tax Return Review',
  'Quarterly Planning Session',
  'IRS Audit Preparation',
  'Estate Planning Discussion',
  'Business Tax Consultation',
  'General Tax Question',
];
